export enum SizeBreakpointsEnum {
  "MOBILE_SMALL" = 412,
}
